import { XY } from 'api/geometry';
import { Subject } from 'rxjs';
/** Provides screen and geographic point information for most observable mouse actions. */
export class MouseEvent {
    equals(otherMouseEvent) {
        return this.screenX === otherMouseEvent.screenX && this.screenY === otherMouseEvent.screenY;
    }
    constructor(event, mapInstance) {
        if (isEsriMouseEvent(event)) {
            const sr = event.mapPoint.spatialReference;
            this.xy = new XY(event.mapPoint.x, event.mapPoint.y, sr.wkid || sr.wkt);
        }
        else {
            // need to use screen point to convert to the map point used in creating the XY
            // however, screenX/Y output the wrong map point value which is why layerX/Y needs to be used
            const mapPoint = mapInstance.mapI.toMap({ x: event.layerX, y: event.layerY });
            const sr = mapPoint.spatialReference;
            this.xy = new XY(mapPoint.x, mapPoint.y, sr.wkid || sr.wkt);
        }
        this.screenY = event.screenY;
        this.screenX = event.screenX;
        this.pageX = event.pageX;
        this.pageY = event.pageY;
        this.offsetX = event.offsetX;
        this.offsetY = event.offsetY;
    }
}
/**
 * Adds a `features` Observable to map clicks for supporting identify through the API
 *
 * @example #### Subscribe to feature list
 *
 * ```js
 * RAMP.mapInstances[0].click.subscribe(a => {
 *     a.features.subscribe(featureList => {...});
 * });
 * ```
 */
export class MapClickEvent extends MouseEvent {
    constructor(event, mapInstance) {
        super(event, mapInstance);
        this._featureSubject = new Subject();
        this.features = this._featureSubject.asObservable();
    }
}
export class PanelEvent {
    constructor(name, node) {
        this._name = name;
        this._content = node;
    }
    get name() {
        return this._name;
    }
    get content() {
        return this._content;
    }
}
function isEsriMouseEvent(event) {
    return !!event.mapPoint;
}
